import { useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CreateRuleForm } from '@/components/rules/CreateRuleForm'
import { type CreateRuleInput, RuleSeverity, RuleType } from '@/domain/rules.types'
import { railAxesToFacets, useAxesWithValues } from '@/hooks/useLibrary'
import { useCreateRule } from '@/hooks/useRules'

const EMPTY: CreateRuleInput = {
	statement: '',
	type: RuleType.REGIONAL,
	severity: RuleSeverity.BLOCKING,
	classification: {},
	appliesTo: [],
}

/** Full-page create-rule route (design §8.13 `rule_new`). New rules land in draft. */
export function CreateRulePage() {
	const navigate = useNavigate()
	const { axes } = useAxesWithValues()
	const facets = useMemo(() => railAxesToFacets(axes), [axes])
	const create = useCreateRule()
	const [form, setForm] = useState<CreateRuleInput>(EMPTY)

	const back = () => {
		void navigate('/rules')
	}

	return (
		<div>
			<div className="mb-3 font-mono text-xs text-ds-text-subtle">
				<Link to="/rules" className="hover:text-ds-text">
					Rules
				</Link>{' '}
				/ <span className="text-ds-text">New</span>
			</div>
			<h1 className="mb-6 font-ds-display text-3xl font-semibold text-ds-text">New rule</h1>
			<CreateRuleForm
				value={form}
				facets={facets}
				onChange={setForm}
				onSubmit={() => create.mutate(form, { onSuccess: back })}
				onCancel={back}
				submitting={create.isPending}
			/>
		</div>
	)
}
